module.exports = __webpack_public_path__ + "img/legal_default_sp.f0c5d39.jpg";